import { registerMutation, registerQuery } from 'data-fetching-client';
import { fetchEmailInsightsRequest, fetchTopNegativeSpotlightsRequest, fetchTopPositiveSpotlightsRequest, fetchSpotlightSentimentCount, submitEmailInsightFeedbackRequest, fetchIndustryName } from 'messaging-publishing-lib/Insights/api';
export const FETCH_EMAIL_INSIGHTS = registerQuery({
  fieldName: 'emailInsights',
  args: ['businessUnitId', 'comparisonType', 'emailContentId'],
  fetcher: fetchEmailInsightsRequest
});
export const FETCH_TOP_POSITIVE_SPOTLIGHTS = registerQuery({
  fieldName: 'topPositiveInsights',
  args: ['businessUnitId', 'comparisonType', 'latestTimestamp'],
  fetcher: fetchTopPositiveSpotlightsRequest
});
export const FETCH_TOP_NEGATIVE_SPOTLIGHTS = registerQuery({
  fieldName: 'topNegativeInsights',
  args: ['businessUnitId', 'comparisonType', 'latestTimestamp'],
  fetcher: fetchTopNegativeSpotlightsRequest
});
export const FETCH_SPOTLIGHT_SENTIMENT_COUNT = registerQuery({
  fieldName: 'spotlightSentimentCount',
  args: ['businessUnitId', 'comparisonType'],
  fetcher: fetchSpotlightSentimentCount
});
export const SUBMIT_INSIGHT_FEEDBACK = registerMutation({
  fieldName: 'insightFeedback',
  args: ['entityId', 'feedbackComment', 'feedbackEntityType', 'feedbackSentiment', 'feedbackCategories'],
  fetcher: submitEmailInsightFeedbackRequest
});
export const FETCH_INDUSTRY_NAME = registerQuery({
  fieldName: 'industryName',
  fetcher: fetchIndustryName
});